import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'searchInput',
        'itemsContainer',
        'selectedSpecialismBubbleContainer',
        'counter',
        'counterValue',
        'specialismContainer',
        'keywordContainer',
        'specialismCheckbox',
        'keywordCheckbox',
        'noResultsContainer',
    ];


    connect() {
        this.updateCount();
        this.createSearchIndex();


        const $items = $(this.itemsContainerTarget).find('input[id^=\'choice-id\']');

        $items.each((index, element) => {
            element.addEventListener('change', () => {
                const value = element.value
                    .replace('specialism_with_group_', '')
                    .replace('specialism_', '')
                    .replace('keyword_', '');

                if (element.checked) {
                    const text = $(element).parent().text().trim();

                    this.addSpecialismOrKeywordBubble(value, text);
                } else {
                    this.removeSpecialismOrKeywordBubble(value);
                }
            });
        });

        this.addEventListenerToSpecialismOrKeywordBubble();
    }

    search(event) {
        const searchValue = this.searchInputTarget.value.toLowerCase();

        if (searchValue === '') {
            this.specialismContainerTargets.forEach(container => {
                container.style.removeProperty('display');
            });

            if ('undefined' === typeof event) {
                return;
            }

            this.specialismContainerTargets.forEach(container => {
                const specialismValue = container.querySelector('input').value
                    .replace('specialism_with_group_', '')
                    .replace('specialism_', '');

                const collapseElement = document.getElementById('specialism-collapse-' + specialismValue);

                if (collapseElement) {
                    const initialState = collapseElement.dataset.initialState === 'true' ? 'show' : 'hide';
                    this.changeCollapse(collapseElement, initialState);
                }
            });

            this.keywordContainerTargets.forEach(container => {
                container.style.removeProperty('display');
            });

            return;
        }

        if (searchValue.length < 3) {
            return;
        }

        const specialismsToShowFully = [];
        const specialismsToShowWithKeywordsHidden = [];
        const keywordsToShow = [];

        this.specialismsNames.forEach(specialism => {
            if (specialism.value.includes(searchValue)) {
                if (!specialismsToShowFully.includes(specialism.id)) {
                    specialismsToShowFully.push(specialism.id);
                }
            }
        });

        this.specialismsNamesNormalized.forEach(specialism => {
            if (specialism.value.includes(searchValue)) {
                if (!specialismsToShowFully.includes(specialism.id)) {
                    specialismsToShowFully.push(specialism.id);
                }
            }
        });

        this.keywordsNames.forEach(keyword => {
            if (keyword.value.includes(searchValue)) {

                if (specialismsToShowFully.includes(keyword.specialismId)) {
                    return;
                }

                if (!specialismsToShowWithKeywordsHidden.includes(keyword.specialismId)) {
                    specialismsToShowWithKeywordsHidden.push(keyword.specialismId);
                }

                if (!keywordsToShow.includes(keyword.id)) {
                    keywordsToShow.push(keyword.id);
                }
            }
        });

        this.keywordsNamesNormalized.forEach(keyword => {
            if (keyword.value.includes(searchValue)) {
                if (specialismsToShowFully.includes(keyword.specialismId)) {
                    return;
                }

                if (!specialismsToShowWithKeywordsHidden.includes(keyword.specialismId)) {
                    specialismsToShowWithKeywordsHidden.push(keyword.specialismId);
                }

                if (!keywordsToShow.includes(keyword.id)) {
                    console.log(keyword.id);
                    keywordsToShow.push(keyword.id);
                }
            }
        });


        this.specialismContainerTargets.forEach(container => {
            const specialismValue = container.querySelector('input').value;
            const specialismId = specialismValue
                .replace('specialism_with_group_', '')
                .replace('specialism_', '');

            const collapseElement = document.getElementById('specialism-collapse-' + specialismId);

            if (specialismsToShowFully.includes(specialismValue)) {
                container.style.removeProperty('display');

                if (collapseElement) {
                    this.changeCollapse(collapseElement, 'show');
                }

                document.querySelectorAll(
                    `[data-essential-form-specialisms-and-keywords-search-target="keywordContainer"] input[data-specialism-id="${specialismId}"]`
                ).forEach(input => {
                    const wrapper = input.closest('[data-essential-form-specialisms-and-keywords-search-target="keywordContainer"]');
                    if (wrapper) {
                        $(wrapper).show();
                    }
                });
            } else if (specialismsToShowWithKeywordsHidden.includes(specialismId)) {
                container.style.removeProperty('display');

                if (collapseElement) {
                    this.changeCollapse(collapseElement, 'show');
                }

                document.querySelectorAll(
                    `[data-essential-form-specialisms-and-keywords-search-target="keywordContainer"] input[data-specialism-id="${specialismId}"]`
                ).forEach(input => {
                    const wrapper = input.closest('[data-essential-form-specialisms-and-keywords-search-target="keywordContainer"]');

                    if (wrapper) {
                        $(wrapper).hide()
                    }
                });
            } else {
                container.style.display = 'none';
                if (collapseElement) {
                    const initial = container.dataset.initialState === 'true' ? 'show' : 'hide';
                    this.changeCollapse(collapseElement, initial);
                }

                document.querySelectorAll(
                    `[data-essential-form-specialisms-and-keywords-search-target="keywordContainer"] input[data-specialism-id="${specialismId}"]`
                ).forEach(input => {
                    const wrapper = input.closest('[data-essential-form-specialisms-and-keywords-search-target="keywordContainer"]');

                    if (wrapper) {
                        $(wrapper).hide();
                    }
                });
            }
        });

        this.keywordContainerTargets.forEach(container => {
            const keywordValue = container.querySelector('input').value;
            if (keywordsToShow.includes(keywordValue)) {
                $(container).show();
            }
        });

        if (
            0 === specialismsToShowFully.length
            && 0 === specialismsToShowWithKeywordsHidden.length
            && 0 === keywordsToShow.length
        ) {
            $(this.noResultsContainerTarget).show();
        } else {
            $(this.noResultsContainerTarget).hide();
        }

    }

    createSearchIndex() {
        this.specialismsNames = this.specialismCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.name,
        }));
        this.specialismsNamesNormalized = this.specialismCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.normalizedName,
        }));
        this.keywordsNames = this.keywordCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.name,
            specialismId: checkbox.dataset.specialismId,
        }));
        this.keywordsNamesNormalized = this.keywordCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.normalizedName,
            specialismId: checkbox.dataset.specialismId,
        }));
    }

    changeCollapse(element, state) {
        const $element = $(element);
        const isOpen = $element.hasClass('show');

        if ('show' === state && isOpen) {
            return;
        }

        if ('hide' === state && !isOpen) {
            return;
        }

        $element.collapse(state);
    }


    normalizeString(string) {
        return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    addSpecialismOrKeywordBubble(value, text) {
        const $container = $(this.selectedSpecialismBubbleContainerTarget);

        const checkbox = document.querySelector(`#choice-id-${value}`);
        const popularity = checkbox?.dataset?.popularity;

        let icon = '';
        if (popularity === 'popular') {
            icon = `<img src="${window.popularityIcons.popular}" class="mw-16 ms-1" alt="Fire-icon">`;
        } else if (popularity === 'niche') {
            icon = `<img src="${window.popularityIcons.niche}" class="mw-16 ms-1" alt="Target-icon">`;
        }

        const $bubble = $(`
        <div id="${value}"
             class="btn-primary-dark btn-rounded px-2 py-2 mr-16 mb-2 rounded-pill fw-semibold d-flex align-items-center">
            ${text} ${icon}
        </div>
    `);

        $container.append($bubble);
    }

    removeSpecialismOrKeywordBubble(value) {
        const $container = $(this.selectedSpecialismBubbleContainerTarget);
        const $bubble = $container.find(`#${value}`);

        $bubble.remove();
    }

    addEventListenerToSpecialismOrKeywordBubble() {
        $(this.selectedSpecialismBubbleContainerTarget).on('click', 'div', (event) => {
            const bubbleId = event.target.id;

            $(event.target).remove();
            const checkbox = $(`#choice-id-${bubbleId}`)[0];
            checkbox.checked = false;

            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateCount() {
        this.counterValueTarget.textContent = this.element.querySelectorAll('input[type="checkbox"]:checked').length;
    }

    expandSpecialismIfNeeded(event) {
        const checkbox = event.target;

        if (checkbox.checked) {
            const specialismId = checkbox.dataset.specialismId;
            const $specialismCollapse = $('#specialism-collapse-' + specialismId);

            if ($specialismCollapse.length > 0) {
                this.changeCollapse($specialismCollapse[0], 'show');
            }
        }
    }

}
